export type { UploadPhotosProps, UploadPhotosState } from './UploadPhotos'
export { default } from './UploadPhotos'
export type { Photo } from './types'
